import React, { useState } from 'react'

import { useParams } from 'react-router-dom';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findProductsByKeyword } from '../../state/Product/Action';
import { colors } from '@mui/material';
import { IMAGES_URL } from "../../config/apiConfig";
const products = [];
const VND = new Intl.NumberFormat('vi-VN', {
  style: 'currency',
  currency: 'VND',
});
export default function Search() {
  const param = useParams();
  const dispatch = useDispatch();
  const [_keyword, _setKeyword] = useState('')
  const [_products, _setProducts] = useState([])
  const [_productKeyword, _setProductKeyword] = useState([])

  useEffect(() => {
    dispatch(findProductsByKeyword("null")).then((Result) => {
      _setProducts(Result.products)
      
    });
  }, [])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {

      dispatch(findProductsByKeyword(_keyword)).then((Result) => {
        _setProductKeyword(Result.products)
        

      });

    }
  };
  const handleGetProduct = () => {
    dispatch(findProductsByKeyword(_keyword)).then((Result) => {
      _setProductKeyword(Result.products)
      
    });

  };


  return (
    <div>

      <div className="">

        <div className=' grid justify-center content-center pt-24 pb-5'>

          <div className=' sm:w-[400px] lg:w-[900px]'>
            <div className="relative">

              <input onChange={(event) => _setKeyword(event.target.value)} onKeyDown={handleKeyDown} type="search" id="default-search" className="block w-full p-4 ps-3 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Nhập thông tin sản phẩm bạn cần tìm ..." required />
              <div className="absolute inset-y-0 start-full flex items-center ps-3" onClick={handleGetProduct}>
                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                </svg>
              </div>

            </div>
          </div>

        </div>
        <div className="p-2 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-5 xl:gap-x-8">
            {_productKeyword?.map((product) => (
              <a key={product.MaSanPham} href={`/san-pham/` + product.MaSanPham + `.html`} className="group">
                <div className="k_img overflow-hidden rounded-lg bg-gray-200 ">
                  <img
                    src={IMAGES_URL + product.MaSanPham?.trim() + "-00.jpg"}
                    alt={product.TenSanPham}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"

                    onError={i => i.target.style.display = 'none'}
                  />
                </div>
                <h3 className="mt-4 text-sm text-gray-700">{product.TenSanPham}</h3>
                <h3 className="mt-4 text-sm text-gray-700">{product.MaSanPham}</h3>
                <p className="mt-1 text-md font-medium text-gray-900">{VND.format(product.DonGia)}</p>
              </a>
            ))}
          </div>
        <div className=' w-full text-end pr-5 pb-5 pt-3'>
          <h2 className=" font-bold text-blue-400 text-lg py-3 justify-end">Có thể bạn quan tâm</h2>
        </div>

        
        <div className="p-2 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-5 xl:gap-x-8">
        {_products?.map((product) => (
              <a key={product.MaSanPham} href={`/san-pham/` + product.MaSanPham +`.html`} className="group">
                <div className="k_img overflow-hidden rounded-lg bg-gray-200 ">
                  <img
                    src={IMAGES_URL + product.MaSanPham?.trim() + "-00.jpg"}
                    alt={product.TenSanPham}
                    className="h-full w-full object-cover object-center group-hover:opacity-75"

                    onError={i => i.target.style.display = 'none'}
                  />
                </div>
                <h3 className="mt-4 text-sm text-gray-700">{product.TenSanPham} {'(' + product.MaSanPham + ')'}</h3>
                
                <p className="mt-1 text-md font-medium text-gray-900">{VND.format(product.DonGia)}</p>
              </a>
            ))}
        </div>


      </div>

    </div>
  )
}
